module.exports = __webpack_public_path__ + "static/img/Samira.4d09ee7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Samira.jpg
// module id = vqCM
// module chunks = 1